/**
 * CSV Utility Functions
 * Shared functions for parsing and handling CSV data across theme components
 */

// Parse CSV function with proper handling of quoted fields
function parseCSV(csvText) {
  // Split into lines and clean up any carriage returns
  const lines = csvText.split('\n').map(line => line.trim()).filter(line => line);
  const reviews = {};
  
  if (lines.length === 0) {
    console.error("No data found in CSV");
    return {};
  }
  
  console.log("Total lines in CSV:", lines.length);
  
  // Parse the header line
  const headerLine = lines[0];
  const headers = parseCSVLine(headerLine);
  console.log("CSV Headers:", headers);
  
  // Find the index of the Review ID column
  const reviewIdIndex = headers.findIndex(header => header === 'Review ID');
  if (reviewIdIndex === -1) {
    console.error("Could not find 'Review ID' column in CSV");
    return {};
  }
  
  // Process each data line
  for (let i = 1; i < lines.length; i++) {
    const values = parseCSVLine(lines[i]);
    
    // Skip if we don't have enough values
    if (values.length < headers.length) {
      console.warn(`Line ${i} has fewer values than headers, skipping`);
      continue;
    }
    
    const review = {};
    
    // Create an object with all the CSV columns
    for (let j = 0; j < headers.length; j++) {
      review[headers[j]] = values[j];
    }
    console.log("Reviews:", review); 
    // Get the Review ID
    const reviewId = values[reviewIdIndex];
    if (reviewId) {
      reviews[reviewId] = review;
    }
  }
  console.log("Reviews:", reviews);
  return reviews;
}

// Helper function to parse a CSV line with proper handling of quoted fields
function parseCSVLine(line) {
  const result = [];
  let current = "";
  let inQuotes = false;
  
  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    
    if (char === '"') {
      // If we see a quote, toggle the inQuotes flag
      inQuotes = !inQuotes;
    } else if (char === ',' && !inQuotes) {
      // If we see a comma and we're not in quotes, end the current field
      result.push(current.trim());
      current = "";
    } else {
      // Otherwise, add the character to the current field
      current += char;
    }
  }
  
  // Add the last field
  result.push(current.trim());
  
  // Clean up any remaining quotes in the values
  return result.map(value => value.replace(/^"|"$/g, ''));
}

// Export the functions to the global scope for use in other files
window.CsvUtils = {
  parseCSV,
  parseCSVLine
};
